// extracted by mini-css-extract-plugin
export default {"topicToggle":"TopicCard_topicToggle__byld3","topicToggleOn":"TopicCard_topicToggleOn__NpAB2","topicLabel":"TopicCard_topicLabel__J8mIG","topicDesc":"TopicCard_topicDesc__jkDUA"};